import { cn } from "../lib/utils";

const STYLES = {
    Paid: "bg-emerald-50 text-emerald-700 border-emerald-200",
    Partial: "bg-amber-50 text-amber-800 border-amber-200",
    Unpaid: "bg-rose-50 text-rose-700 border-rose-200",
    Locked: "bg-amber-50 text-amber-800 border-amber-200",
    Finalized: "bg-amber-50 text-amber-800 border-amber-200",
    Draft: "bg-slate-100 text-slate-700 border-slate-300",
    Open: "bg-slate-100 text-slate-700 border-slate-300",
    Active: "bg-emerald-50 text-emerald-700 border-emerald-200",
    Paused: "bg-amber-50 text-amber-800 border-amber-200",
    // Iter 58 — "Fully Settled — Pending TDS Attachment" is economically
    // paid (no client receivable). Distinct teal palette signals "settled
    // but reconciliation still pending" so collections operators visually
    // skip it while finance team picks it up.
    "Fully Settled — Pending TDS Attachment": "bg-teal-50 text-teal-800 border-teal-200",
    // Iter 64 — Cancelled invoices: muted slate with strike-through styling
    // applied at consumer level via `compact` chip + line-through on the
    // invoice number. Tone is deliberately neutral — cancelled isn't a
    // failure state, it's a statutorily inactive record.
    Cancelled: "bg-slate-200 text-slate-700 border-slate-400 line-through decoration-slate-500/60",
};

// Iter 58 — concise label for the long status string in dense table cells.
const COMPACT_LABEL = {
    "Fully Settled — Pending TDS Attachment": "Settled · Pending TDS",
    Cancelled: "Cancelled",
};

export const StatusBadge = ({ status, className, icon, children, compact = false, "data-testid": testId }) => {
    const tone = STYLES[status] || STYLES.Draft;
    const label = children ?? (compact ? COMPACT_LABEL[status] : undefined) ?? status;
    return (
        <span
            data-testid={testId}
            title={status}
            className={cn(
                "inline-flex items-center gap-1 rounded px-2 py-0.5 text-[11px] font-semibold border tracking-wide whitespace-nowrap",
                tone,
                className
            )}
        >
            {icon}
            {label}
        </span>
    );
};

export default StatusBadge;
